// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__5x2cA","sm":"loader_sm__PYrYM","md":"loader_md__v2gfa","lg":"loader_lg__n1z5n","center":"loader_center__BWtmw"};